import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { event: String, googleAdsEventId: String }

  trackEvent() {
    var eventName = this.eventValue
    var googleAdsEventId = this.googleAdsEventIdValue

    if (window.rails_env === "production") {
      if (typeof fbq !== "undefined") {
        fbq("trackCustom", eventName)
      }
    }
    else if (window.rails_env === "development") {
      console.info(`Facebook Ads tracked: event \"${eventName}\"`)
      console.info(`Google Ads tracked: event ID \"${googleAdsEventId}\"`)
    }

    return false
  }
}
